import { Navigate, useLocation } from 'react-router';
import { ReactNode } from 'react';

import { PATH_SETTINGS } from 'domains/userSettings/Routes';
import { isSlackConfirmationQuery } from 'domains/userSettings/utils/isSlackConfirmationQuery';

interface ISlackConfirmationGuardProps {
  children?: ReactNode;
}

export const SlackConfirmationGuard = ({
  children,
}: ISlackConfirmationGuardProps) => {
  const location = useLocation();

  const isSlackConfirmation = isSlackConfirmationQuery(location.search || '');

  if (isSlackConfirmation) {
    return <>{children}</>;
  }

  return <Navigate to={PATH_SETTINGS} replace />;
};
